<ngx-spinner
    bdColor="rgba(108,114,124,0.8)"
    size = "medium"
    color = "#ffffff"
    type = "ball-clip-rotate-pulse"
    [fullScreen] = "true">
</ngx-spinner>
